import type { CoachingGoal } from '@efdigital/ll-addon-data';
import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

interface GoalPreviewRowSignature {
  Args: {
    goal: CoachingGoal;
    detail: string;
    programId?: string;
  };
  Element: HTMLDivElement;
}

function goalMonth(iso: string | null | undefined): string {
  if (!iso) {
    return 'DUE';
  }

  const date = new Date(iso);

  if (Number.isNaN(date.getTime())) {
    return 'DUE';
  }

  return date
    .toLocaleString(undefined, { month: 'short', timeZone: 'UTC' })
    .toUpperCase();
}

function goalDay(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }

  const date = new Date(iso);

  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  return date.toLocaleString(undefined, { day: 'numeric', timeZone: 'UTC' });
}

/** Compact goal row matching the dashboard session list. */
const GoalPreviewRow = <template>
  <div class="card border rounded-3 position-relative" ...attributes>
    <div class="card-body p-3">
      <div class="d-flex align-items-center gap-3">
        <div class="flex-shrink-0 text-center lh-1">
          <p class="gud-eyebrow text-primary mb-0">
            {{goalMonth @goal.targetDate}}
          </p>
          <p class="fs-2 fw-bold mb-0 text-body-emphasis">{{goalDay
              @goal.targetDate
            }}</p>
        </div>

        <div class="flex-grow-1 min-w-0">
          <h3
            class="h6 fw-bold mb-1 text-truncate text-body-emphasis"
          >{{@goal.title}}</h3>
          <p class="small text-body-secondary mb-0">{{@detail}}</p>
        </div>

        <div class="flex-shrink-0">
          <iconify-icon
            inline
            icon="ph:caret-right"
            class="fs-4 text-primary"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
    {{#if @programId}}
      <LinkTo
        @route="coaching.coachee.cohort.goals.goal"
        @model={{@goal.id}}
        class="stretched-link"
      >
        <span class="visually-hidden">Open {{@goal.title}}</span>
      </LinkTo>
    {{/if}}
  </div>
</template> satisfies TOC<GoalPreviewRowSignature>;

export default GoalPreviewRow;
